import { useAppTheme } from "../../useAppTheme";
import { useDevice } from "../../useDevice";
import Box from "../Box";
import CustomChip from "../CustomChip";
import { CustomListSubheader } from "../CustomListSubheader";
import { PremiumChip } from "../PremiumChip";
import type { SectionHeader as SectionHeaderType } from "./types";

type Props = SectionHeaderType & {
	appFont: string;
};

export const SectionHeader = ({ appFont, title, chip, premiumChip }: Props) => {
	const theme = useAppTheme();
	const { isMobile } = useDevice();
	const hasChip = Boolean(premiumChip || chip);
	return (
		<Box
			justifyContent="space-between"
			alignItems="center"
			flexDirection="row"
			paddingTop={isMobile ? 8 : 16}
		>
			<CustomListSubheader font={appFont} enableGutters={isMobile}>
				{title}
			</CustomListSubheader>
			{hasChip ? (
				<Box paddingRight={isMobile ? 16 : 0}>
					{premiumChip ? (
						<PremiumChip
							variant={premiumChip.variant}
							onPress={premiumChip.onPress}
						/>
					) : chip ? (
						<CustomChip
							onPress={chip.onPress}
							icon={chip.icon}
							style={{
								backgroundColor: chip.background,
							}}
							textStyle={{
								color: theme.colors.onSurface,
							}}
						>
							{chip.label}
						</CustomChip>
					) : null}
				</Box>
			) : null}
		</Box>
	);
};
